// extracted by mini-css-extract-plugin
export default {"price":"NumericValue_price__7BkU8","highlight":"NumericValue_highlight__6M1ww"};